module.exports = __webpack_public_path__ + "static/media/mujerhoy.bb05002e.png";